/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * MovingWorlds API
 * OpenAPI spec version: 0.1.0
 */
import { useMutation, useQuery } from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
} from '@tanstack/react-query';

import type {
  HTTPValidationError,
  LoginGoogleParams,
  LoginLinkedinParams,
  LoginParameters,
  RequestPasswordResetParameters,
  ResendResetEmailParameters,
  ResendVerificationEmailParameters,
  SignUpWithPasswordParameters,
  UpdatePasswordParameters,
  VerifyEmailParams,
} from './platformapi.schemas';

import loginWithPasswordMutator from '../custom-axios-instance';
import authGoogleMutator from '../custom-axios-instance';
import callbackLinkedinMutator from '../custom-axios-instance';
import loginGoogleMutator from '../custom-axios-instance';
import loginLinkedinMutator from '../custom-axios-instance';
import logoutMutator from '../custom-axios-instance';
import requestPasswordResetMutator from '../custom-axios-instance';
import resendResetEmailMutator from '../custom-axios-instance';
import resendVerificationEmailMutator from '../custom-axios-instance';
import signUpWithPasswordMutator from '../custom-axios-instance';
import updatePasswordMutator from '../custom-axios-instance';
import verifyEmailMutator from '../custom-axios-instance';

/**
 * Attempts to log in a user via email and password
 * @summary Login With Password
 */
export const loginWithPassword = (loginParameters: LoginParameters, signal?: AbortSignal) => {
  return loginWithPasswordMutator<unknown>({
    url: `${import.meta.env['VITE_API_HOST']}/login/`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: loginParameters,
    signal,
  });
};

export const getLoginWithPasswordMutationOptions = <
  TError = void | HTTPValidationError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof loginWithPassword>>,
    TError,
    { data: LoginParameters },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof loginWithPassword>>,
  TError,
  { data: LoginParameters },
  TContext
> => {
  const mutationKey = ['loginWithPassword'];
  const { mutation: mutationOptions } =
    options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
        options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof loginWithPassword>>,
    { data: LoginParameters }
  > = (props) => {
    const { data } = props ?? {};

    return loginWithPassword(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type LoginWithPasswordMutationResult = NonNullable<
  Awaited<ReturnType<typeof loginWithPassword>>
>;
export type LoginWithPasswordMutationBody = LoginParameters;
export type LoginWithPasswordMutationError = void | HTTPValidationError;

/**
 * @summary Login With Password
 */
export const useLoginWithPassword = <TError = void | HTTPValidationError, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof loginWithPassword>>,
      TError,
      { data: LoginParameters },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof loginWithPassword>>,
  TError,
  { data: LoginParameters },
  TContext
> => {
  const mutationOptions = getLoginWithPasswordMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary Auth Google
 */
export const authGoogle = (signal?: AbortSignal) => {
  return authGoogleMutator<unknown>({
    url: `${import.meta.env['VITE_API_HOST']}/login/auth/google`,
    method: 'GET',
    signal,
  });
};

export const getAuthGoogleQueryKey = () => {
  return [`${import.meta.env['VITE_API_HOST']}/login/auth/google`] as const;
};

export const getAuthGoogleQueryOptions = <
  TData = Awaited<ReturnType<typeof authGoogle>>,
  TError = void,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof authGoogle>>, TError, TData>>;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getAuthGoogleQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof authGoogle>>> = ({ signal }) =>
    authGoogle(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof authGoogle>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type AuthGoogleQueryResult = NonNullable<Awaited<ReturnType<typeof authGoogle>>>;
export type AuthGoogleQueryError = void;

export function useAuthGoogle<TData = Awaited<ReturnType<typeof authGoogle>>, TError = void>(
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof authGoogle>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof authGoogle>>,
          TError,
          Awaited<ReturnType<typeof authGoogle>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useAuthGoogle<TData = Awaited<ReturnType<typeof authGoogle>>, TError = void>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof authGoogle>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof authGoogle>>,
          TError,
          Awaited<ReturnType<typeof authGoogle>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useAuthGoogle<TData = Awaited<ReturnType<typeof authGoogle>>, TError = void>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof authGoogle>>, TError, TData>>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Auth Google
 */

export function useAuthGoogle<TData = Awaited<ReturnType<typeof authGoogle>>, TError = void>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof authGoogle>>, TError, TData>>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getAuthGoogleQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Callback Linkedin
 */
export const callbackLinkedin = (signal?: AbortSignal) => {
  return callbackLinkedinMutator<unknown>({
    url: `${import.meta.env['VITE_API_HOST']}/login/auth/linkedin`,
    method: 'GET',
    signal,
  });
};

export const getCallbackLinkedinQueryKey = () => {
  return [`${import.meta.env['VITE_API_HOST']}/login/auth/linkedin`] as const;
};

export const getCallbackLinkedinQueryOptions = <
  TData = Awaited<ReturnType<typeof callbackLinkedin>>,
  TError = void,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof callbackLinkedin>>, TError, TData>>;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getCallbackLinkedinQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof callbackLinkedin>>> = ({ signal }) =>
    callbackLinkedin(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof callbackLinkedin>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type CallbackLinkedinQueryResult = NonNullable<Awaited<ReturnType<typeof callbackLinkedin>>>;
export type CallbackLinkedinQueryError = void;

export function useCallbackLinkedin<
  TData = Awaited<ReturnType<typeof callbackLinkedin>>,
  TError = void,
>(
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof callbackLinkedin>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof callbackLinkedin>>,
          TError,
          Awaited<ReturnType<typeof callbackLinkedin>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useCallbackLinkedin<
  TData = Awaited<ReturnType<typeof callbackLinkedin>>,
  TError = void,
>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof callbackLinkedin>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof callbackLinkedin>>,
          TError,
          Awaited<ReturnType<typeof callbackLinkedin>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useCallbackLinkedin<
  TData = Awaited<ReturnType<typeof callbackLinkedin>>,
  TError = void,
>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof callbackLinkedin>>, TError, TData>>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Callback Linkedin
 */

export function useCallbackLinkedin<
  TData = Awaited<ReturnType<typeof callbackLinkedin>>,
  TError = void,
>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof callbackLinkedin>>, TError, TData>>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getCallbackLinkedinQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Login Google
 */
export const loginGoogle = (params?: LoginGoogleParams, signal?: AbortSignal) => {
  return loginGoogleMutator<unknown>({
    url: `${import.meta.env['VITE_API_HOST']}/login/google`,
    method: 'GET',
    params,
    signal,
  });
};

export const getLoginGoogleQueryKey = (params?: LoginGoogleParams) => {
  return [`${import.meta.env['VITE_API_HOST']}/login/google`, ...(params ? [params] : [])] as const;
};

export const getLoginGoogleQueryOptions = <
  TData = Awaited<ReturnType<typeof loginGoogle>>,
  TError = void | HTTPValidationError,
>(
  params?: LoginGoogleParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof loginGoogle>>, TError, TData>>;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getLoginGoogleQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof loginGoogle>>> = ({ signal }) =>
    loginGoogle(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof loginGoogle>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type LoginGoogleQueryResult = NonNullable<Awaited<ReturnType<typeof loginGoogle>>>;
export type LoginGoogleQueryError = void | HTTPValidationError;

export function useLoginGoogle<
  TData = Awaited<ReturnType<typeof loginGoogle>>,
  TError = void | HTTPValidationError,
>(
  params: undefined | LoginGoogleParams,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof loginGoogle>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof loginGoogle>>,
          TError,
          Awaited<ReturnType<typeof loginGoogle>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useLoginGoogle<
  TData = Awaited<ReturnType<typeof loginGoogle>>,
  TError = void | HTTPValidationError,
>(
  params?: LoginGoogleParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof loginGoogle>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof loginGoogle>>,
          TError,
          Awaited<ReturnType<typeof loginGoogle>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useLoginGoogle<
  TData = Awaited<ReturnType<typeof loginGoogle>>,
  TError = void | HTTPValidationError,
>(
  params?: LoginGoogleParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof loginGoogle>>, TError, TData>>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Login Google
 */

export function useLoginGoogle<
  TData = Awaited<ReturnType<typeof loginGoogle>>,
  TError = void | HTTPValidationError,
>(
  params?: LoginGoogleParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof loginGoogle>>, TError, TData>>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getLoginGoogleQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Login Linkedin
 */
export const loginLinkedin = (params?: LoginLinkedinParams, signal?: AbortSignal) => {
  return loginLinkedinMutator<unknown>({
    url: `${import.meta.env['VITE_API_HOST']}/login/linkedin`,
    method: 'GET',
    params,
    signal,
  });
};

export const getLoginLinkedinQueryKey = (params?: LoginLinkedinParams) => {
  return [
    `${import.meta.env['VITE_API_HOST']}/login/linkedin`,
    ...(params ? [params] : []),
  ] as const;
};

export const getLoginLinkedinQueryOptions = <
  TData = Awaited<ReturnType<typeof loginLinkedin>>,
  TError = void | HTTPValidationError,
>(
  params?: LoginLinkedinParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof loginLinkedin>>, TError, TData>>;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getLoginLinkedinQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof loginLinkedin>>> = ({ signal }) =>
    loginLinkedin(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof loginLinkedin>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type LoginLinkedinQueryResult = NonNullable<Awaited<ReturnType<typeof loginLinkedin>>>;
export type LoginLinkedinQueryError = void | HTTPValidationError;

export function useLoginLinkedin<
  TData = Awaited<ReturnType<typeof loginLinkedin>>,
  TError = void | HTTPValidationError,
>(
  params: undefined | LoginLinkedinParams,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof loginLinkedin>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof loginLinkedin>>,
          TError,
          Awaited<ReturnType<typeof loginLinkedin>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useLoginLinkedin<
  TData = Awaited<ReturnType<typeof loginLinkedin>>,
  TError = void | HTTPValidationError,
>(
  params?: LoginLinkedinParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof loginLinkedin>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof loginLinkedin>>,
          TError,
          Awaited<ReturnType<typeof loginLinkedin>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useLoginLinkedin<
  TData = Awaited<ReturnType<typeof loginLinkedin>>,
  TError = void | HTTPValidationError,
>(
  params?: LoginLinkedinParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof loginLinkedin>>, TError, TData>>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Login Linkedin
 */

export function useLoginLinkedin<
  TData = Awaited<ReturnType<typeof loginLinkedin>>,
  TError = void | HTTPValidationError,
>(
  params?: LoginLinkedinParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof loginLinkedin>>, TError, TData>>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getLoginLinkedinQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Logout
 */
export const logout = (signal?: AbortSignal) => {
  return logoutMutator<unknown>({
    url: `${import.meta.env['VITE_API_HOST']}/login/logout`,
    method: 'GET',
    signal,
  });
};

export const getLogoutQueryKey = () => {
  return [`${import.meta.env['VITE_API_HOST']}/login/logout`] as const;
};

export const getLogoutQueryOptions = <
  TData = Awaited<ReturnType<typeof logout>>,
  TError = void,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof logout>>, TError, TData>>;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getLogoutQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof logout>>> = ({ signal }) => logout(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof logout>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type LogoutQueryResult = NonNullable<Awaited<ReturnType<typeof logout>>>;
export type LogoutQueryError = void;

export function useLogout<TData = Awaited<ReturnType<typeof logout>>, TError = void>(
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof logout>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof logout>>,
          TError,
          Awaited<ReturnType<typeof logout>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useLogout<TData = Awaited<ReturnType<typeof logout>>, TError = void>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof logout>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof logout>>,
          TError,
          Awaited<ReturnType<typeof logout>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useLogout<TData = Awaited<ReturnType<typeof logout>>, TError = void>(
  options?: { query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof logout>>, TError, TData>> },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Logout
 */

export function useLogout<TData = Awaited<ReturnType<typeof logout>>, TError = void>(
  options?: { query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof logout>>, TError, TData>> },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getLogoutQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Request Password Reset
 */
export const requestPasswordReset = (
  requestPasswordResetParameters: RequestPasswordResetParameters,
  signal?: AbortSignal,
) => {
  return requestPasswordResetMutator<unknown>({
    url: `${import.meta.env['VITE_API_HOST']}/login/request-password-reset`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: requestPasswordResetParameters,
    signal,
  });
};

export const getRequestPasswordResetMutationOptions = <
  TError = void | HTTPValidationError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof requestPasswordReset>>,
    TError,
    { data: RequestPasswordResetParameters },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof requestPasswordReset>>,
  TError,
  { data: RequestPasswordResetParameters },
  TContext
> => {
  const mutationKey = ['requestPasswordReset'];
  const { mutation: mutationOptions } =
    options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
        options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof requestPasswordReset>>,
    { data: RequestPasswordResetParameters }
  > = (props) => {
    const { data } = props ?? {};

    return requestPasswordReset(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type RequestPasswordResetMutationResult = NonNullable<
  Awaited<ReturnType<typeof requestPasswordReset>>
>;
export type RequestPasswordResetMutationBody = RequestPasswordResetParameters;
export type RequestPasswordResetMutationError = void | HTTPValidationError;

/**
 * @summary Request Password Reset
 */
export const useRequestPasswordReset = <TError = void | HTTPValidationError, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof requestPasswordReset>>,
      TError,
      { data: RequestPasswordResetParameters },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof requestPasswordReset>>,
  TError,
  { data: RequestPasswordResetParameters },
  TContext
> => {
  const mutationOptions = getRequestPasswordResetMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary Resend Reset Email
 */
export const resendResetEmail = (
  resendResetEmailParameters: ResendResetEmailParameters,
  signal?: AbortSignal,
) => {
  return resendResetEmailMutator<unknown>({
    url: `${import.meta.env['VITE_API_HOST']}/login/resend-reset-email`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: resendResetEmailParameters,
    signal,
  });
};

export const getResendResetEmailMutationOptions = <
  TError = void | HTTPValidationError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof resendResetEmail>>,
    TError,
    { data: ResendResetEmailParameters },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof resendResetEmail>>,
  TError,
  { data: ResendResetEmailParameters },
  TContext
> => {
  const mutationKey = ['resendResetEmail'];
  const { mutation: mutationOptions } =
    options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
        options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof resendResetEmail>>,
    { data: ResendResetEmailParameters }
  > = (props) => {
    const { data } = props ?? {};

    return resendResetEmail(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type ResendResetEmailMutationResult = NonNullable<
  Awaited<ReturnType<typeof resendResetEmail>>
>;
export type ResendResetEmailMutationBody = ResendResetEmailParameters;
export type ResendResetEmailMutationError = void | HTTPValidationError;

/**
 * @summary Resend Reset Email
 */
export const useResendResetEmail = <TError = void | HTTPValidationError, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof resendResetEmail>>,
      TError,
      { data: ResendResetEmailParameters },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof resendResetEmail>>,
  TError,
  { data: ResendResetEmailParameters },
  TContext
> => {
  const mutationOptions = getResendResetEmailMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary Resend Verification Email
 */
export const resendVerificationEmail = (
  resendVerificationEmailParameters: ResendVerificationEmailParameters,
  signal?: AbortSignal,
) => {
  return resendVerificationEmailMutator<unknown>({
    url: `${import.meta.env['VITE_API_HOST']}/login/resend-verification-email`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: resendVerificationEmailParameters,
    signal,
  });
};

export const getResendVerificationEmailMutationOptions = <
  TError = void | HTTPValidationError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof resendVerificationEmail>>,
    TError,
    { data: ResendVerificationEmailParameters },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof resendVerificationEmail>>,
  TError,
  { data: ResendVerificationEmailParameters },
  TContext
> => {
  const mutationKey = ['resendVerificationEmail'];
  const { mutation: mutationOptions } =
    options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
        options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof resendVerificationEmail>>,
    { data: ResendVerificationEmailParameters }
  > = (props) => {
    const { data } = props ?? {};

    return resendVerificationEmail(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type ResendVerificationEmailMutationResult = NonNullable<
  Awaited<ReturnType<typeof resendVerificationEmail>>
>;
export type ResendVerificationEmailMutationBody = ResendVerificationEmailParameters;
export type ResendVerificationEmailMutationError = void | HTTPValidationError;

/**
 * @summary Resend Verification Email
 */
export const useResendVerificationEmail = <TError = void | HTTPValidationError, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof resendVerificationEmail>>,
      TError,
      { data: ResendVerificationEmailParameters },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof resendVerificationEmail>>,
  TError,
  { data: ResendVerificationEmailParameters },
  TContext
> => {
  const mutationOptions = getResendVerificationEmailMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * Creates a user account via email and password if it does not already exist
 * @summary Sign Up With Password
 */
export const signUpWithPassword = (
  signUpWithPasswordParameters: SignUpWithPasswordParameters,
  signal?: AbortSignal,
) => {
  return signUpWithPasswordMutator<unknown>({
    url: `${import.meta.env['VITE_API_HOST']}/login/sign-up`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: signUpWithPasswordParameters,
    signal,
  });
};

export const getSignUpWithPasswordMutationOptions = <
  TError = void | HTTPValidationError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof signUpWithPassword>>,
    TError,
    { data: SignUpWithPasswordParameters },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof signUpWithPassword>>,
  TError,
  { data: SignUpWithPasswordParameters },
  TContext
> => {
  const mutationKey = ['signUpWithPassword'];
  const { mutation: mutationOptions } =
    options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
        options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof signUpWithPassword>>,
    { data: SignUpWithPasswordParameters }
  > = (props) => {
    const { data } = props ?? {};

    return signUpWithPassword(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type SignUpWithPasswordMutationResult = NonNullable<
  Awaited<ReturnType<typeof signUpWithPassword>>
>;
export type SignUpWithPasswordMutationBody = SignUpWithPasswordParameters;
export type SignUpWithPasswordMutationError = void | HTTPValidationError;

/**
 * @summary Sign Up With Password
 */
export const useSignUpWithPassword = <TError = void | HTTPValidationError, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof signUpWithPassword>>,
      TError,
      { data: SignUpWithPasswordParameters },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof signUpWithPassword>>,
  TError,
  { data: SignUpWithPasswordParameters },
  TContext
> => {
  const mutationOptions = getSignUpWithPasswordMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * Update password via email verification token
 * @summary Update Password
 */
export const updatePassword = (
  updatePasswordParameters: UpdatePasswordParameters,
  signal?: AbortSignal,
) => {
  return updatePasswordMutator<unknown>({
    url: `${import.meta.env['VITE_API_HOST']}/login/update-password`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: updatePasswordParameters,
    signal,
  });
};

export const getUpdatePasswordMutationOptions = <
  TError = void | HTTPValidationError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updatePassword>>,
    TError,
    { data: UpdatePasswordParameters },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updatePassword>>,
  TError,
  { data: UpdatePasswordParameters },
  TContext
> => {
  const mutationKey = ['updatePassword'];
  const { mutation: mutationOptions } =
    options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
        options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updatePassword>>,
    { data: UpdatePasswordParameters }
  > = (props) => {
    const { data } = props ?? {};

    return updatePassword(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdatePasswordMutationResult = NonNullable<Awaited<ReturnType<typeof updatePassword>>>;
export type UpdatePasswordMutationBody = UpdatePasswordParameters;
export type UpdatePasswordMutationError = void | HTTPValidationError;

/**
 * @summary Update Password
 */
export const useUpdatePassword = <TError = void | HTTPValidationError, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof updatePassword>>,
      TError,
      { data: UpdatePasswordParameters },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof updatePassword>>,
  TError,
  { data: UpdatePasswordParameters },
  TContext
> => {
  const mutationOptions = getUpdatePasswordMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary Verify Email
 */
export const verifyEmail = (params: VerifyEmailParams, signal?: AbortSignal) => {
  return verifyEmailMutator<unknown>({
    url: `${import.meta.env['VITE_API_HOST']}/login/verify-email`,
    method: 'GET',
    params,
    signal,
  });
};

export const getVerifyEmailQueryKey = (params?: VerifyEmailParams) => {
  return [
    `${import.meta.env['VITE_API_HOST']}/login/verify-email`,
    ...(params ? [params] : []),
  ] as const;
};

export const getVerifyEmailQueryOptions = <
  TData = Awaited<ReturnType<typeof verifyEmail>>,
  TError = void | HTTPValidationError,
>(
  params: VerifyEmailParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof verifyEmail>>, TError, TData>>;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getVerifyEmailQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof verifyEmail>>> = ({ signal }) =>
    verifyEmail(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof verifyEmail>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type VerifyEmailQueryResult = NonNullable<Awaited<ReturnType<typeof verifyEmail>>>;
export type VerifyEmailQueryError = void | HTTPValidationError;

export function useVerifyEmail<
  TData = Awaited<ReturnType<typeof verifyEmail>>,
  TError = void | HTTPValidationError,
>(
  params: VerifyEmailParams,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof verifyEmail>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof verifyEmail>>,
          TError,
          Awaited<ReturnType<typeof verifyEmail>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useVerifyEmail<
  TData = Awaited<ReturnType<typeof verifyEmail>>,
  TError = void | HTTPValidationError,
>(
  params: VerifyEmailParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof verifyEmail>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof verifyEmail>>,
          TError,
          Awaited<ReturnType<typeof verifyEmail>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useVerifyEmail<
  TData = Awaited<ReturnType<typeof verifyEmail>>,
  TError = void | HTTPValidationError,
>(
  params: VerifyEmailParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof verifyEmail>>, TError, TData>>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Verify Email
 */

export function useVerifyEmail<
  TData = Awaited<ReturnType<typeof verifyEmail>>,
  TError = void | HTTPValidationError,
>(
  params: VerifyEmailParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof verifyEmail>>, TError, TData>>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getVerifyEmailQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}
